import { render, staticRenderFns } from "./UsersRole.vue?vue&type=template&id=f9050380&scoped=true"
import script from "./UsersRole.vue?vue&type=script&lang=js"
export * from "./UsersRole.vue?vue&type=script&lang=js"
import style0 from "./UsersRole.vue?vue&type=style&index=0&id=f9050380&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9050380",
  null
  
)

export default component.exports